<div
  class="catalog-actions"
  fxFlex="100"
  fxLayout="row"
  fxLayout.mm-mobile="row wrap"
  fxLayoutAlign.mm-mobile="space-between"
  fxLayout.mm-tablet="row wrap"
  fxLayoutAlign.mm-tablet="space-between"
  [class.sticky]="isSticky"
>
  <app-search-sort-toggler
    [isCategoryPage]="isCategoryPage"
    class="catalog-actions__sort-toggler"
    [class.sticky]="isSticky"
  >
  </app-search-sort-toggler>
  <div *ngIf="!isDesktop" class="catalog-actions__filters" (click)="onOpenFilters()">
    <button
      [class.sticky]="isSticky"
      class="catalog-actions__filter-btn"
      [ngClass]="{ 'zero-count': (filtersCount$ | async) === 0 }"
      mm-button
      iconButton="true"
      [mmTestTarget]="'toogle-filter-button'"
    >
      <mm-icon name="filter" class="filter__btn-icon"></mm-icon>
      {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.FILTERS_BUTTON.TEXT' | translate }}
    </button>
    <ng-container *ngIf="filtersCount$ | async as filtersCount">
      <div class="catalog-actions__filter-btn-count">
        {{ filtersCount$ | async }}
      </div>
    </ng-container>
  </div>
</div>
